import React, { useRef, useState } from 'react'
import styles from './PostSuccess.module.scss'
import confetie from './../../../../../assets/lottie/lottie-confetie.json';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import GooglePlayIcon from '../../../../../assets/svg/google-play.svg';
import AppstoreIcon from '../../../../../assets/svg/appstore.svg';
import { AppButton } from '../../../../elements/app-button';
import { LayoutHeader } from '../../../../elements/layout-header';
import { AppLayout } from '../../../../elements/app-layout';
import { EventDTO } from '../../../../../infrastructure/dtos/guest';

export function PostSuccess(props: {hideSuccessPage: () => void; event?: EventDTO['moment'] | null}) {
    const lottieRef = useRef<LottieRefCurrentProps>(null);
    const [showLoti, setShowLoti] = useState(true);
  return (
    <AppLayout>
        <div className={styles.page}>
            <LayoutHeader>
                <div className={styles.container}>
                    <label className={styles.cover}>
                        🎉
                    </label>
                    <label className={styles.title}>
                        Great job!
                    </label>
                    <label className={styles.subTitle}>
                        {props.event?.host.first_name} will love your post.
                    </label>
                </div>
                
            </LayoutHeader>

            <div className={styles.contentsContainer}>
                <div className={styles.messageContainer}>
                    <h3>
                        But here’s the thing…
                    </h3>
                    <label>Most photos and videos get lost in your camera roll. {props.event?.host.first_name} uses Momap to turn moments into unforgettable memories. Don’t let your memories fade. Download Momap today.</label>

                    <div>
                        <a href='https://play.google.com/store/apps/details?id=io.momap.app&hl=en' target='__blank'>
                            <img src={GooglePlayIcon as any} alt='google-play' />
                        </a>
                        <a href='https://apps.apple.com/us/app/momap-make-memories/id6744412699' target='__blank'>
                            <img src={AppstoreIcon as any} alt='appstore' />
                        </a>
                    </div>
                </div>

                <AppButton title='Post More Content' onClick={props.hideSuccessPage}/>
            </div>

            {(showLoti) && <div className={styles.celebrate}>
                <Lottie 
                    lottieRef={lottieRef}
                    animationData={confetie} 
                    autoplay={true}
                    loop={false}
                    onComplete={() => {
                        setShowLoti(false)
                    }}
                />
            </div>}
        </div>
    </AppLayout>
  )
}
